import { GetPublicItineraryResponse } from '@orbit/api-types'
import { publicApi, publicQueryRetry } from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const usePublicItinerary = (tripCode: string | undefined) => {
	return useQuery<GetPublicItineraryResponse>({
		queryKey: queryKeys.publicItinerary(tripCode),
		queryFn: async () => {
			if (!tripCode) throw new Error('Trip code is required')
			const response = await publicApi.get<GetPublicItineraryResponse>(
				`/trips/${tripCode}/public-itinerary`,
			)
			return response.data
		},
		enabled: !!tripCode,
		retry: publicQueryRetry,
	})
}
